<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @reset="$gjReset"
            @query="$gjNoticeQuery"
            >
          <gj-country-server-select
              v-model="filter.countryMarketValue"
          ></gj-country-server-select>
          <gj-select
              v-model="filter.reportType"
              :options="[
                {id: 1, text: 'Date-Range Reports'},
                // {id: 2, text: 'Invoiced'},
                {id: 3, text: 'Detail Page Sales and Traffic by SKU'},
                {id: 4, text: 'Detail Page Sales and Traffic by Child Item'},
                {id: 5, text: 'Detail Page Sales and Traffic by Time'},
                {id: 6, text: 'Detail Page Sales and Traffic by Parent Item'},
              ]"
              placeholder="报告名称"
          ></gj-select>
          <gj-select
              v-model="filter.status"
              :options="[
                {id: 0, text: '获取中'},
                {id: 1, text: '等待获取'},
                {id: 2, text: '获取成功'},
                {id: 3, text: '获取失败'},
                {id: 4, text: '上传成功'},
                {id: 5, text: '上传失败'},
              ]"
              placeholder="获取结果"
          ></gj-select>
          <gj-input
              v-model="filter.keyword"
              placeholder="任务编号"
          ></gj-input>
          <gj-select-date-picker
              v-model="filter.date"
              :options="[
                {id: 1, text: '报告时间'},
                {id: 2, text: '任务生成时间'},
                {id: 3, text: '更新时间'},
              ]"
              type="daterange"
              :width="['120px']"
          ></gj-select-date-picker>
          <template #right>
            <gj-tool-group help></gj-tool-group>
          </template>
        </app-filter-group>
      </template>
      <template #table>
        <gj-table
            name="cloud-plugin-report"
            adaptParent
            :data="tableData"
            :pagination="pagination"
            :loading="loading"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
            :columns="columns">
          <template v-slot:reportDateRange="{row}">
            {{row.rangeStartDate | defaultShow}} ~ {{row.rangeEndDate | defaultShow}}
          </template>
        </gj-table>
      </template>
       <template #base-content>
          <new-user-guide  v-if="userGuideState" ref="newUserGuide" ></new-user-guide>
       </template>
    </app-base-main>
</template>

<script>
  import {queryMixin, userGuideMixin, selectionMixin } from "../../../../minxins";
  import {getCloudReport} from "../../../../api/tool";
  import {isMeaningful} from "../../../../utils/common";
  import {convertToDate} from "../../../../utils/date.util";
  import NewUserGuide from "./components/new-user-guide";
  export default {
    name: "app-cloud-plugin-report",
    components: { NewUserGuide },
    mixins: [queryMixin, userGuideMixin, selectionMixin ],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'marketName', header: '店铺', field: 'marketName', minWidth: '120px'},
          {id: 'countryCode', header: '国家', field: 'countryCode', minWidth: '50px'},
          {id: 'documentFile', header: '报告名称', field: 'documentFile', overflowLine: 2, minWidth: '120px'},
          {id: 'reportDateRange', header: '报告时间范围', field: 'slot:reportDateRange', minWidth: '170px'},
          {id: 'taskId', header: '任务编号', field: 'id', minWidth: '70px'},
          {id: 'getType', header: '获取方式', field: 'option:takeWay', minWidth: '70px', options: [
              {id: 1, text: '手动'},
              {id: 0, text: '自动'},
            ]},
          {id: 'reportStatus', header: '获取结果', field: 'option:reportStatus', minWidth: '70px', options: [
              {id: 0, text: '获取中'},
              {id: 1, text: '等待获取'},
              {id: 2, text: '获取成功'},
              {id: 3, text: '获取失败'},
              {id: 4, text: '上传成功'},
              {id: 5, text: '上传失败'},
            ]},
          {id: 'failureReason', header: '结果原因', field: 'failureReason', minWidth: '100px', overflowLine: 2},
          {id: 'createTime', header: '任务生成时间', field: 'createTime', minWidth: '140px', sortable: true},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '150px', sortable: true},
        ],
        filter: {
          countryMarketValue: null,
          keyword: null,
          status: null,
          reportType: null,
          date: {
            key: 1,
            value: null
          }
        },
        cacheOptions: {
          useCache: true,
        }
      }
    },
    methods: {
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{countryMarketValue: *}}
       */
      $gjCacheCallback(params) {
        return {
          countryMarketValue: params.countryMarketValue
        };
      },
      $gjQuery() {
        if (isMeaningful(this.filter.keyword) && isNaN(this.filter.keyword)) {
          this.$gjMessage.error('任务编号必须是数字类型');
          return;
        }
        this.loading = true;
        getCloudReport({
          model: {
            marketIds: isMeaningful(this.filter.countryMarketValue) ? this.filter.countryMarketValue.marketIds : null,
            countryCodes: isMeaningful(this.filter.countryMarketValue) ? this.filter.countryMarketValue.countryIds : null,
            id: this.filter.keyword,
            reportStatus: this.filter.status,
            dateType: this.filter.date.key,
            reportType: this.filter.reportType,
            startDate: isMeaningful(this.filter.date.value) ? convertToDate(this.filter.date.value[0]) : null,
            endDate: isMeaningful(this.filter.date.value) ? convertToDate(this.filter.date.value[1]) : null,
          },
          ...this.querySort,
          ...this.queryPagination,
        }).then((data) => {
          this.tableData = data.records;
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            countryMarketValue: null,
            keyword: null,
            status: null,
            date: {
              key: 1,
              value: null
            }
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>


